import { PageMeta } from '@/components/page-meta';
import { UserProfile } from '@/utils/self-hosted/components';

/**
 * Account screen for self-hosted deployments.
 *
 * The shared `SettingsPage` is gated to enterprise, so `/settings/account` previously redirected
 * self-hosted users to the dashboard root — leaving no in-app way to change a password. This page
 * fills that gap with the one thing a self-hosted operator actually needs there.
 */
export function SelfHostedAccountPage() {
  return (
    <>
      <PageMeta title="Account" />
      <div className="flex w-full justify-center py-8">
        <UserProfile />
      </div>
    </>
  );
}

export default SelfHostedAccountPage;
